<template>
  <div class="dialog-mask payment-method-dialog" :class="{ open: isOpen }">
    <div class="dialog-content">
      <!-- <div class="dialog-header" v-if="title">{{title}}</div> -->
      <!-- <div class="dialog-body" v-if="loading">
        Caricamento...
      </div> -->
      <div class="dialog-body"><!-- v-else -->
        <p>{{ 'HowToPay' | lang }}</p>
        <ul class="nav">
          <li v-if="satispay" @click="sweetClose('satispay')"><span><span class="iconbox" style="background-image:url('/img/satispay-icon.png')"></span>Satispay</span></li>
          <li v-if="creditcard" @click="sweetClose('creditcard')"><span><span class="iconbox" style="background-image:url('/img/creditcard-icon.png')"></span>{{ 'CreditCard' | lang }}</span></li>
          <li v-if="paypal" @click="sweetClose('paypal')"><span><span class="iconbox" style="background-image:url('/img/paypal-icon.svg')"></span>Paypal</span></li>
        </ul>
      </div>
      <div class="dialog-footer">
        <button @click="sweetClose(null)">{{ 'Undo' | lang }}</button>    
      </div>
    </div>
  </div>
</template>

<script>
import dialogMixin from '@/mixins/dialogMixin'

export default {
  name: 'CartPaymentMethodDialog',
  mixins: [ dialogMixin ],
  props: {
    satispay: {
      type: Boolean,
      required: false,
      default: false
    },
    creditcard: {
      type: Boolean,
      required: false,
      default: true
    },
    paypal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      // loading: false,
      // methods: []
    }
  },
  computed: {
    numberOfChoices () {
      return (this.satispay ? 1 : 0) + (this.creditcard ? 1 : 0) + (this.paypal ? 1 : 0)
    }
  },
  methods: {
    deleteThisPayment (method, idx) {
      this._deletePaymentMethod(method.Token).then(resp => {
        console.log(resp)
        this.methods.splice(idx, 1)
      }).catch(err => {
        console.error(err)
      })
    }
  },
  mounted () {
    if (this.numberOfChoices === 1) {
      if (this.satispay) return 'satispay'
      if (this.creditcard) return 'creditcard'
      if (this.paypal) return 'paypal'
    } else if (this.numberOfChoices === 0) {
      // restituisci errore
      return 'error'
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

.nav .iconbox {
  width: 2rem;
  height: 2rem;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.nav .iconbox {
  margin-right: 1rem;
}

</style>
